import styled from '@emotion/styled';


const CentralizedFullScreenContainer = styled("div")({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});


export default CentralizedFullScreenContainer;
